import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";
import { TableHead } from "./ui/table";

const getAlignClass = (align) => {
  if (align === "right") return "justify-end w-full";
  if (align === "center") return "justify-center w-full";
  return "";
};

const getIcon = (isActive, sortDir) => {
  if (!isActive) return ArrowUpDown;
  return sortDir === "asc" ? ArrowUp : ArrowDown;
};

/**
 * Clickable table header that toggles sort for a given columnKey.
 * Shows an indicator icon (asc / desc / neutral).
 */
export const SortableTableHead = ({
  columnKey,
  sortKey,
  sortDir,
  onToggle,
  className = "",
  align = "left",
  children,
}) => {
  const isActive = sortKey === columnKey;
  const Icon = getIcon(isActive, sortDir);
  const alignClass = getAlignClass(align);

  return (
    <TableHead className={className}>
      <button
        type="button"
        onClick={() => onToggle(columnKey)}
        className={`inline-flex items-center gap-1 text-sm font-medium transition-colors hover:text-slate-900 ${
          isActive ? "text-slate-900" : "text-slate-500"
        } ${alignClass}`}
        data-testid={`sort-${columnKey}`}
      >
        <span>{children}</span>
        <Icon className={`h-3.5 w-3.5 ${isActive ? "" : "opacity-40"}`} />
      </button>
    </TableHead>
  );
};

export default SortableTableHead;
